import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";

@Component({
  selector: "wireless-service-tile",
  templateUrl: "wireless-service-tile.html",
  styleUrls: ["../service-tile/service-tile.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, MatTooltipModule, NgxSkeletonLoaderModule, RouterLink, TranslatePipe],
})
export class WirelessServiceTile {
  protected serviceUrl = input.required<string>();
  protected serviceIcon = input.required<string>();
  protected serviceTitle = input.required<string>();
  protected subscriptionCount = input.required<number>();
  protected isLoading = input<boolean>();

  protected serviceRoute = computed(() => ["/diensten", this.serviceUrl()]);
}
